var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWalletconnectpay = function SvgWalletconnectpay(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#3B99FC",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.685 8.027c2.935-2.874 7.695-2.874 10.63 0l.353.346a.362.362 0 0 1 0 .52l-1.208 1.183a.19.19 0 0 1-.266 0l-.486-.476c-2.048-2.005-5.368-2.005-7.416 0l-.52.51a.19.19 0 0 1-.266 0L6.297 8.927a.363.363 0 0 1 0-.52l.388-.38Zm13.13 2.447 1.075 1.053a.363.363 0 0 1 0 .52l-4.85 4.749a.382.382 0 0 1-.531 0l-3.443-3.37a.095.095 0 0 0-.132 0l-3.442 3.37a.382.382 0 0 1-.532 0l-4.85-4.749a.362.362 0 0 1 0-.52l1.076-1.053a.382.382 0 0 1 .531 0l3.442 3.37a.095.095 0 0 0 .133 0l3.442-3.37a.382.382 0 0 1 .532 0l3.442 3.37a.095.095 0 0 0 .133 0l3.442-3.37a.382.382 0 0 1 .531 0Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWalletconnectpay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "walletconnectpay.7b168ace305d8b95ab588d87152ef098.svg";